import { createUseStyles } from 'react-jss'

const styleOverride = createUseStyles({
  root: {
    width: '118px',
    height: '118px',
    fill: 'none',
    viewBox: '0px 0px 118px 118px',
    '& path': {
      stroke: 'black',
      strokeMiterlimit: '10',
      strokeWidth: '0.5px',
    },
    '& .principalPath': {
      fill: 'white',
      strokeWidth: '1.2px',
    },
    '& g': {
      filter: 'url(#filter0_d)',
      '& circle': {
        fill: 'black',
        cx: '59px',
        cy: '55px',
        r: '55px',
        fillOpacity: '0.1',
        shapeRendering: 'crispEdges',
      },
    },
    '& defs': {
      '& filter': {
        x: '0',
        y: '0',
        width: '118px',
        height: '118px',
        filterUnits: 'userSpaceOnUse',
        colorInterpolationFilters: 'sRGB',
        '& feFlood': {
          floodOpacity: '0',
        },
      },
    },
  },
})

export default styleOverride
